var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('h1',[_vm._v("Generate Url for Registration")]),_vm._v(" "),_c('button',{staticClass:"button_danger",on:{"click":_vm.generateUrl}},[_vm._v("Generate")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h4',[_vm._v(_vm._s(_vm.url))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }